<template>
  <div id="login">
    <div id="login_con">
      <div class="title"></div>
      <div class="cysj"></div>
      <form id="form_panel">
        <label class="name">
          <i :class="{ active: nameclass }"></i>
          <input class="radius" type="text" v-model="name" placeholder="用户名" @focus="nameclass = true"
            @blur="nameclass = false" />
        </label>
        <label class="psw">
          <i :class="{ active: pswclass }"></i>
          <input class="radius" type="password" v-model="psw" placeholder="密码" @keyup.enter="login"
            @focus="pswclass = true" @blur="pswclass = false" />
        </label>
        <label for="remember" class="rember">
          <input type="checkbox" id="remember" v-model="remember" />
          <span>记住密码</span>
        </label>
        <label>
          <div id="btn" @click="login">登录</div>
        </label>
      </form>
      <div>
        <p>
          <a href="http://www.yiweihang.com" target="_blank">易景产品论坛 </a>
        </p>
        <p>
          <a href="http://www.evialab.com" target="_blank">北京易伟航科技有限公司主页</a>
        </p>
      </div>
    </div>
    <i class="down"></i>
    <div class="beianhao">
      <p style="color: #939393">
        版权所有： 北京易伟航科技有限公司&nbsp;&nbsp;&nbsp;<a style="text-decoration: none; color: #939393"
          href="https://beian.miit.gov.cn" target="_blank">京ICP备09010697号-1</a>
      </p>
      <div style="width: 210px">
        <i></i>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802030299" style="
            vertical-align: bottom;
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
          "><img :src="require('../assets/login/jinghui.png')" style="float: left" />
          <p style="
              float: left;
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
              color: #939393;
            ">
            京公网安备 11010802030299号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      nameclass: false,
      pswclass: false,
      name: "",
      psw: "",
      remember: false,
    };
  },
  methods: {
    setRemember() {
      if (this.remember) {
        localStorage.setItem("gxmhxt_user", this.name);
        localStorage.setItem("gxmhxt_pwd", this.psw);
      } else {
        localStorage.removeItem("gxmhxt_user");
        localStorage.removeItem("gxmhxt_pwd");
      }
    },
    login() {
      let that = this;
      if (that.name == "evia" && that.psw == "123") {
        sessionStorage.setItem("token", "123456");
        that.setRemember();  // 是否记住密码
        that.$router.push("/map");
      }
      else {
        that.axios.post("/qqearth/login?username=" + that.name + "&password=" + that.psw).then(function (data) {
            if (data.status == 200) {
              if (data.data.status) {
                sessionStorage.setItem("token", "123456");
                that.setRemember();  // 是否记住密码
                that.$router.push("/map");
              } else {
                sessionStorage.removeItem("token");
                alert(data.data.info);
              }
            }
          });
      }
    },
    init() {
      if (localStorage.getItem("gxmhxt_user")) {
        this.name = localStorage.getItem("gxmhxt_user");
        this.psw = localStorage.getItem("gxmhxt_pwd");
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#login {
  width: 100%;
  height: 100%;
  background: url("../assets/login/beijing.png") no-repeat center center;
  background-size: cover;
  background-size: 100% 100%;
}

#login_con {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .title {
    width: 44rem;
    height: 6rem;
    margin: 0 auto 1rem;
    background: url("../assets/login/title.png");
    background-size: 100% 100%;
  }

  .cysj {
    width: 37.1rem;
    height: 10.4rem;
    margin: 0 auto 2rem;
    background: url("../assets/login/cysj.png");
    background-size: 100% 100%;
  }

  div {
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #ccc;

    &:first-child {
      margin-right: 2rem;
    }
  }
}

#form_panel {
  width: 36rem;
  height: 22rem;
  background: url("../assets/login/biaodan.png");
  background-size: 100% 100%;
  padding: 5rem 0rem;
  border-radius: 1rem;
  box-shadow: #7d7d7d 0rem 0rem 0.6rem;
  margin: 0 auto 5rem;

  label {
    display: block;
    height: 3.8rem;
    width: 26.8rem;
    position: relative;
    margin: 0 auto;
    margin-bottom: 2rem;

    &.psw {
      i {
        width: 1.8rem;
        height: 1.8rem;
        background: url("../assets/login/password2.png") no-repeat 0 0;
        background-size: 100% 100%;

        &.active {
          background: url("../assets/login/password1.png") no-repeat 0 0;
          background-size: 100% 100%;
        }
      }
    }

    &.rember {
      cursor: pointer;
      line-height: 3rem;
      text-align: left;

      span {
        color: #fff;
      }

      input {
        vertical-align: text-bottom;
        cursor: pointer;

        &[type="checkbox"]::after {
          background-color: #fff;
          // border: 0.1rem solid #1d5fc0;
          color: #000;
          width: 1.5rem;
          height: 1.5rem;
          display: inline-block;
          visibility: visible;
          padding-left: 0rem;
          text-align: center;
          content: " ";
          border-radius: 0.2rem;
        }
      }

      input[type="checkbox"]:checked::after {
        content: "✓";
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        line-height: 2rem;
        background-color: #1d5fc0;
      }
    }

    input:not([type="checkbox"]) {
      height: calc(100% - 0.4rem);
      width: calc(100% - 5.2rem);
      line-height: 3.6rem;
      padding-left: 5rem;
      font-size: 12px;
      border: 0;
      border: 1px solid #eaeaea;
    }

    span {
      font-size: 12px;
      margin-left: 1rem;
      color: #fff;
    }

    i {
      width: 2.2rem;
      height: 2.2rem;
      display: inline-block;
      position: absolute;
      left: 14px;
      top: 8px;
      background: url("../assets/login/username2.png") no-repeat 0 0;
      background-size: 100% 100%;

      &.active {
        background: url("../assets/login/username1.png") no-repeat 0 0;
        background-size: 100% 100%;
      }
    }

    .radius {
      color: #fff;
      border-radius: 1rem;
      background-color: transparent;
    }
  }
}

#btn {
  width: 27rem;
  height: 3.8rem;
  background-color: transparent;
  background: url("../assets/login/login.png") no-repeat 0 0;
  background-size: 100% 100%;
  text-align: center;
  line-height: 3.6rem;
  color: #fff;
  cursor: pointer;
  letter-spacing: 0.3rem;
}

.down {
  position: absolute;
  display: inline-block;
  width: 8.5rem;
  height: 3rem;
  bottom: 1.5rem;
  left: 2rem;
  background: url("../assets/login/logo.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.beianhao {
  color: #ccc;
  text-align: center;
  position: absolute;
  text-align: center;
  bottom: 1.5rem;
  right: 2rem;
  width: 100%;

  p {
    display: inline-block;
    margin-top: 1rem;
    font-size: 12px;
  }

  div {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue